<template>
  <AiEducationLayout
    ><div class="teacher-workbench">
      <ContentWrap>
        <div class="head"
          ><div><h2>教师工作台</h2><p>围绕班级、课程、备课、作业和学情开展日常教学</p></div
          ><el-button
            v-hasPermi="['ai-education:teaching-class:write']"
            type="primary"
            @click="openClass()"
            ><Icon icon="ep:plus" /> 新建教学班</el-button
          ></div
        >
        <div class="workflow">
          <button
            v-for="item in workflows"
            :key="item.title"
            type="button"
            class="workflow-card"
            @click="router.push(item.path)"
          >
            <span class="workflow-icon" :class="item.tone"><Icon :icon="item.icon" :size="22" /></span>
            <div class="workflow-copy">
              <span class="workflow-title">{{ item.title }}</span>
              <span class="workflow-desc">{{ item.desc }}</span>
            </div>
            <span class="workflow-arrow"><Icon icon="ep:arrow-right" /></span>
          </button>
        </div>
      </ContentWrap>

      <ContentWrap>
        <div class="toolbar"
          ><el-select v-model="schoolId" clearable placeholder="全部学校" @change="loadClasses"
            ><el-option
              v-for="item in schools"
              :key="item.id"
              :label="item.name"
              :value="item.id" /></el-select
          ><el-button @click="loadClasses"><Icon icon="ep:refresh" /></el-button
        ></div>
        <el-table v-loading="loading" :data="teachingClasses">
          <el-table-column prop="name" label="教学班" min-width="160" />
          <el-table-column label="学校" min-width="140"
            ><template #default="s">{{ schoolName(s.row.schoolId) }}</template></el-table-column
          >
          <el-table-column label="行政班" min-width="140"
            ><template #default="s">{{ adminClassName(s.row.classId) }}</template></el-table-column
          >
          <el-table-column label="课程" min-width="180"
            ><template #default="s">{{
              courseName(s.row.trainCourseId)
            }}</template></el-table-column
          >
          <el-table-column label="教师" min-width="140"
            ><template #default="s">{{ teacherName(s.row.teacherId) }}</template></el-table-column
          >
          <el-table-column label="开始时间" width="170">
            <template #default="s">{{ formatDateTime(s.row.startTime) }}</template>
          </el-table-column>
          <el-table-column label="结束时间" width="170">
            <template #default="s">{{ formatDateTime(s.row.endTime) }}</template>
          </el-table-column>
          <el-table-column label="状态" width="90"
            ><template #default="s"
              ><el-tag :type="s.row.status === 20 ? 'success' : 'info'">{{
                s.row.status === 20 ? '进行中' : '停用'
              }}</el-tag></template
            ></el-table-column
          >
          <el-table-column label="操作" width="200" fixed="right"
            ><template #default="s"
              ><el-button
                v-hasPermi="['ai-education:teaching-class:write']"
                link
                type="primary"
                @click="openStudents(s.row)"
                >学生</el-button
              ><el-button
                v-hasPermi="['ai-education:teaching-class:write']"
                link
                type="primary"
                @click="openClass(s.row)"
                >编辑</el-button
              ><el-button
                v-hasPermi="['ai-education:teaching-class:delete']"
                link
                type="danger"
                @click="removeClass(s.row.id)"
                >删除</el-button
              ></template
            ></el-table-column
          >
        </el-table>
      </ContentWrap>
    </div>

    <Dialog v-model="classDialog" :title="classForm.id ? '编辑教学班' : '新建教学班'" width="620px">
      <el-form :model="classForm" label-width="90px">
        <el-form-item label="学校" required
          ><el-select
            v-model="classForm.schoolId"
            class="w-100%"
            filterable
            @change="onSchoolChange"
            ><el-option
              v-for="item in schools"
              :key="item.id"
              :label="item.name"
              :value="item.id" /></el-select
        ></el-form-item>
        <el-form-item label="行政班"
          ><el-select v-model="classForm.classId" class="w-100%" clearable filterable
            ><el-option
              v-for="item in adminClasses"
              :key="item.id"
              :label="item.name"
              :value="item.id" /></el-select
        ></el-form-item>
        <el-form-item label="课程" required
          ><el-select
            v-model="classForm.trainCourseId"
            class="w-100%"
            filterable
            clearable
            :placeholder="courses.length ? '选择培训课程' : '暂无课程，请先在培训模块创建并上架'"
            ><el-option
              v-for="item in courses"
              :key="item.id"
              :label="item.title || item.name"
              :value="item.id" /></el-select
          ><div v-if="!courses.length" class="course-empty-tip"
            >下拉无数据时请先到「培训 / 课程」创建课程，或在课程包中关联培训课后重试</div
          ></el-form-item
        >
        <el-form-item label="教师" required
          ><el-select v-model="classForm.teacherId" class="w-100%" filterable
            ><el-option
              v-for="item in teachers"
              :key="item.id"
              :label="item.nickname || item.name || item.username"
              :value="item.id" /></el-select
        ></el-form-item>
        <el-form-item label="班级名称" required><el-input v-model="classForm.name" /></el-form-item>
        <el-form-item label="教学周期"
          ><el-date-picker
            v-model="classPeriod"
            type="datetimerange"
            value-format="YYYY-MM-DDTHH:mm:ss"
            class="w-100%"
        /></el-form-item>
        <el-form-item label="状态"><el-switch v-model="classEnabled" /></el-form-item>
      </el-form>
      <template #footer
        ><el-button @click="classDialog = false">取消</el-button
        ><el-button type="primary" :loading="classSaving" @click="saveClass"
          >保存</el-button
        ></template
      >
    </Dialog>

    <Dialog v-model="studentDialog" :title="studentDialogTitle" width="720px">
      <div class="student-dialog">
        <div class="student-toolbar">
          <el-select
            v-model="selectedStudentIds"
            multiple
            filterable
            remote
            reserve-keyword
            collapse-tags
            collapse-tags-tooltip
            :max-collapse-tags="2"
            :remote-method="onSearchStudents"
            :loading="studentSearchLoading"
            class="student-select"
            placeholder="搜索昵称 / 手机号添加学生"
          >
            <el-option
              v-for="item in studentOptions"
              :key="item.id"
              :label="formatStudentLabel(item)"
              :value="item.id"
            >
              <div class="opt-row">
                <span class="opt-name">{{ item.nickname || item.name || '未命名' }}</span>
                <span class="opt-meta">{{ item.mobile || '-' }} · ID {{ item.id }}</span>
              </div>
            </el-option>
          </el-select>
          <el-tag type="info" effect="plain">已选 {{ selectedStudentIds.length }} 人</el-tag>
        </div>

        <el-table :data="rosterRows" border size="small" max-height="360" empty-text="暂无学生，请上方搜索添加">
          <el-table-column label="学生" min-width="200">
            <template #default="{ row }">
              <div class="stu-cell">
                <el-avatar :size="32" :src="row.avatar">{{ avatarText(row) }}</el-avatar>
                <div class="stu-info">
                  <div class="stu-name">{{ row.studentName || row.nickname || '未命名' }}</div>
                  <div class="stu-sub">ID {{ row.studentId }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="手机号" prop="mobile" min-width="130">
            <template #default="{ row }">{{ row.mobile || '-' }}</template>
          </el-table-column>
          <el-table-column label="操作" width="90" align="center">
            <template #default="{ row }">
              <el-button link type="danger" @click="removeRosterStudent(row.studentId)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <template #footer>
        <el-button @click="studentDialog = false">取消</el-button>
        <el-button type="primary" :loading="studentsSaving" @click="saveStudents">保存学生名单</el-button>
      </template>
    </Dialog>
  </AiEducationLayout>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import request from '@/config/axios'
import * as Api from '@/api/aiEducation'
import { useBusinessOptions } from './useBusinessOptions'
import AiEducationLayout from './layout/AiEducationLayout.vue'

defineOptions({ name: 'AiEducationTeacher' })
const router = useRouter()
const message = useMessage()
const loading = ref(false)
const schoolId = ref<number>()

function pad2(n: number) {
  return String(n).padStart(2, '0')
}
/** 兼容毫秒时间戳 / 字符串，避免表格显示原始 Unix 时间 */
function formatDateTime(v: any) {
  if (v == null || v === '') return '—'
  let d: Date | null = null
  if (typeof v === 'number' || /^\d{10,13}$/.test(String(v).trim())) {
    const n = Number(v)
    const ms = String(v).trim().length <= 10 ? n * 1000 : n
    d = new Date(ms)
  } else if (typeof v === 'string') {
    if (/^\d{4}-\d{2}-\d{2}/.test(v)) return v.length >= 16 ? v.slice(0, 19) : v
    const parsed = new Date(v.replace(/-/g, '/'))
    if (!Number.isNaN(parsed.getTime())) d = parsed
  } else if (v instanceof Date) {
    d = v
  }
  if (!d || Number.isNaN(d.getTime())) return '—'
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())} ${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`
}
const classDialog = ref(false)
const studentDialog = ref(false)
const currentClassId = ref(0)
const classPeriod = ref<string[]>([])
const classEnabled = ref(true)
const classSaving = ref(false)
const studentsSaving = ref(false)
const studentSearchLoading = ref(false)
const adminClasses = ref<Api.ClassVO[]>([])
const teachers = ref<any[]>([])
const selectedStudentIds = ref<number[]>([])
const currentClassName = ref('')
const rosterMap = ref<Record<number, Api.TeachingClassStudentVO>>({})
const classForm = reactive<Partial<Api.TeachingClassVO>>({})
const {
  schools,
  teachingClasses,
  courses,
  students,
  loadBaseOptions,
  searchStudents,
  schoolName,
  courseName
} = useBusinessOptions()

const studentDialogTitle = computed(() =>
  currentClassName.value ? `教学班学生 · ${currentClassName.value}` : '教学班学生'
)

const studentOptions = computed(() => {
  const map = new Map<number, any>()
  Object.values(rosterMap.value).forEach((s) => {
    map.set(s.studentId, {
      id: s.studentId,
      nickname: s.nickname || s.studentName,
      name: s.studentName,
      mobile: s.mobile,
      avatar: s.avatar
    })
  })
  students.value.forEach((s) => map.set(s.id, s))
  return [...map.values()]
})

const rosterRows = computed(() =>
  selectedStudentIds.value.map((id) => {
    const hit = rosterMap.value[id]
    if (hit) return hit
    const opt = students.value.find((s) => s.id === id)
    return {
      studentId: id,
      studentName: opt?.nickname || opt?.name || `用户 #${id}`,
      nickname: opt?.nickname,
      mobile: opt?.mobile,
      avatar: undefined
    } as Api.TeachingClassStudentVO
  })
)

const formatStudentLabel = (item: any) => {
  const name = item.nickname || item.name || item.studentName || '未命名'
  const mobile = item.mobile ? ` · ${item.mobile}` : ''
  return `${name}${mobile}`
}
const avatarText = (row: Api.TeachingClassStudentVO) =>
  (row.studentName || row.nickname || '?').slice(0, 1)

const upsertRosterFromOption = (id: number) => {
  if (rosterMap.value[id]) return
  const opt = students.value.find((s) => s.id === id)
  rosterMap.value[id] = {
    studentId: id,
    studentName: opt?.nickname || opt?.name || `用户 #${id}`,
    nickname: opt?.nickname,
    mobile: opt?.mobile
  }
}

watch(
  selectedStudentIds,
  (ids) => {
    ids.forEach((id) => upsertRosterFromOption(id))
  },
  { deep: true }
)

const onSearchStudents = async (keyword: string) => {
  studentSearchLoading.value = true
  try {
    await searchStudents(keyword)
  } finally {
    studentSearchLoading.value = false
  }
}

const removeRosterStudent = (studentId: number) => {
  selectedStudentIds.value = selectedStudentIds.value.filter((id) => id !== studentId)
}
const workflows = [
  {
    title: '课程与章节',
    desc: '编排课程内容与学习顺序',
    icon: 'ep:collection',
    tone: 'blue',
    path: '/ai-Application-center/course'
  },
  {
    title: '资源与备课',
    desc: '上传资源并生成备课草稿',
    icon: 'ep:upload-filled',
    tone: 'green',
    path: '/ai-Application-center/ai-education/operations'
  },
  {
    title: '作业与批改',
    desc: '发布作业并完成反馈',
    icon: 'ep:document-checked',
    tone: 'amber',
    path: '/ai-Application-center/ai-education/learning'
  },
  {
    title: '学情与报告',
    desc: '分析学习效果并导出报告',
    icon: 'ep:data-analysis',
    tone: 'purple',
    path: '/ai-Application-center/ai-education/analytics'
  }
]
const teacherName = (id?: number) =>
  teachers.value.find((v) => v.id === id)?.nickname ||
  teachers.value.find((v) => v.id === id)?.name ||
  '-'
const adminClassName = (id?: number) =>
  adminClasses.value.find((v) => v.id === id)?.name || (id ? `班级 #${id}` : '-')
const loadClasses = async () => {
  loading.value = true
  try {
    teachingClasses.value = await Api.getTeachingClassList({ schoolId: schoolId.value })
  } finally {
    loading.value = false
  }
}
const loadAdminClasses = async (id?: number) => {
  adminClasses.value = id ? await Api.getClassList(id) : []
}
const onSchoolChange = async () => {
  classForm.classId = undefined
  await loadAdminClasses(classForm.schoolId)
}
const openClass = async (row?: Api.TeachingClassVO) => {
  Object.assign(
    classForm,
    row || {
      id: undefined,
      schoolId: undefined,
      classId: undefined,
      trainCourseId: undefined,
      teacherId: undefined,
      name: '',
      status: 20
    }
  )
  classPeriod.value = row?.startTime && row?.endTime ? [row.startTime, row.endTime] : []
  classEnabled.value = row?.status !== 30
  await loadAdminClasses(row?.schoolId)
  classDialog.value = true
}
const saveClass = async () => {
  if (!classForm.schoolId || !classForm.trainCourseId || !classForm.teacherId || !classForm.name)
    return message.warning('请选择学校、课程和教师并填写班级名称')
  classSaving.value = true
  try {
    await Api.saveTeachingClass({
      ...classForm,
      name: classForm.name.trim(),
      startTime: classPeriod.value?.[0],
      endTime: classPeriod.value?.[1],
      status: classEnabled.value ? 20 : 30
    })
    message.success('教学班已保存')
    classDialog.value = false
    await loadClasses()
  } finally {
    classSaving.value = false
  }
}
const removeClass = async (id: number) => {
  await message.delConfirm()
  await Api.deleteTeachingClass(id)
  message.success('已删除')
  await loadClasses()
}
const openStudents = async (row: Api.TeachingClassVO) => {
  currentClassId.value = row.id!
  currentClassName.value = row.name || ''
  rosterMap.value = {}
  selectedStudentIds.value = []
  await searchStudents()
  const list = (await Api.getTeachingClassStudents(row.id!)) || []
  const nextMap: Record<number, Api.TeachingClassStudentVO> = {}
  list.forEach((v) => {
    nextMap[v.studentId] = v
  })
  rosterMap.value = nextMap
  selectedStudentIds.value = list.map((v) => v.studentId)
  studentDialog.value = true
}
const saveStudents = async () => {
  if (!currentClassId.value) return message.warning('请先选择教学班')
  studentsSaving.value = true
  try {
    await Api.replaceTeachingClassStudents({
      teachingClassId: currentClassId.value,
      studentIds: [...new Set(selectedStudentIds.value)]
    })
    message.success('学生名单已更新')
    studentDialog.value = false
  } finally {
    studentsSaving.value = false
  }
}
onMounted(async () => {
  await loadBaseOptions()
  try {
    teachers.value = await request.get({
      url: '/system/user/simple-list',
      headers: { ignoreError: true }
    })
  } catch {
    teachers.value = []
  }
  await loadClasses()
})
</script>

<style scoped>
.teacher-workbench {
  padding: 0;
}
.head,
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.head h2 {
  margin: 0;
  font-size: 20px;
}
.head p {
  margin: 6px 0 0;
  color: #7b8794;
}
.workflow {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  margin-top: 20px;
}
.workflow-card {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
  padding: 14px 16px;
  border: 1px solid #e6eaf0;
  border-radius: 8px;
  background: #fff;
  text-align: left;
  cursor: pointer;
  writing-mode: horizontal-tb !important;
  text-orientation: mixed;
  direction: ltr;
}
.workflow-icon {
  display: inline-flex;
  flex: 0 0 40px;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
}
.workflow-copy {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  writing-mode: horizontal-tb !important;
}
.workflow-title,
.workflow-desc {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  writing-mode: horizontal-tb !important;
  word-break: keep-all;
}
.workflow-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.35;
}
.workflow-desc {
  color: #8a95a2;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
}
.workflow-arrow {
  flex: 0 0 16px;
  color: #c0c4cc;
}
.toolbar {
  justify-content: flex-start;
  gap: 8px;
  margin-bottom: 14px;
}
.toolbar .el-select {
  width: 220px;
}
.blue {
  color: #2673dd;
  background: #eaf2ff;
}
.green {
  color: #16846b;
  background: #e7f7f2;
}
.amber {
  color: #b56c10;
  background: #fff3df;
}
.purple {
  color: #7656b5;
  background: #f1ecfb;
}
.student-dialog {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.student-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
}
.student-select {
  flex: 1;
}
.opt-row {
  display: flex;
  flex-direction: column;
  line-height: 1.35;
  padding: 4px 0;
}
.opt-name {
  font-weight: 600;
  color: #303133;
}
.opt-meta {
  font-size: 12px;
  color: #909399;
}
.stu-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}
.stu-info {
  min-width: 0;
}
.stu-name {
  font-weight: 600;
  color: #303133;
}
.stu-sub {
  margin-top: 2px;
  font-size: 12px;
  color: #909399;
}
@media (width <= 900px) {
  .workflow {
    grid-template-columns: repeat(2, 1fr);
  }
}
.course-empty-tip {
  margin-top: 6px;
  color: #e6a23c;
  font-size: 12px;
  line-height: 1.4;
}
</style>
